import { CircularGauge } from '@/components/ui/circular-gauge'
import type { HomeReadiness, HomeStats } from '@/lib/api/home'

interface Props {
  stats: HomeStats
  readiness: HomeReadiness
}

export function ProgressStatsRow({ stats, readiness }: Props) {
  return (
    <section
      className="rounded-xl border border-[#e8e4df] bg-white p-6"
      aria-label="Progress stats"
    >
      <div className="grid grid-cols-2 gap-6 sm:grid-cols-4 place-items-center">
        <CircularGauge value={Math.round(readiness.completion_pct)} label="Progress" />
        <CircularGauge value={Math.round(readiness.attendance_pct)} label="Attendance" />
        <CircularGauge value={Math.round(readiness.avg_score)} label="Avg Score" />
        <div className="flex flex-col items-center gap-1">
          <span className="font-heading text-3xl font-bold text-[#1a1714]">
            {stats.problems_solved}
          </span>
          <span className="text-xs font-medium text-[#9a9589]">Solved</span>
        </div>
      </div>
    </section>
  )
}
